// EmailJS configuration
const SERVICE_ID  = "service_81layl7";
const TEMPLATE_RECEIVED = "template_j02fn7b";
const TEMPLATE_SHIPPED  = "template_wya5pcf";
const PUBLIC_KEY  = "oW8gCKtgFLN9BXapk";

// Load EmailJS dynamically
async function getEmailJS() {
  if (window.emailjs) return window.emailjs;
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/email.min.js";
    script.onload = () => {
      window.emailjs.init(PUBLIC_KEY);
      resolve(window.emailjs);
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// Send "Package Received" notification
export async function sendPackageReceivedEmail({ customerEmail, customerName, packageId, trackingNumber, description, weight, warehouse, unit }) {
  try {
    const ejs = await getEmailJS();
    await ejs.send(SERVICE_ID, TEMPLATE_RECEIVED, {
      email:          customerEmail,
      customer_name:  customerName,
      package_id:     packageId,
      tracking_number: trackingNumber || "—",
      description:    description || "Package",
      weight:         weight || "—",
      warehouse:      warehouse || "USA",
      unit:           unit || "7000",
    });
    console.log("Email sent: package received");
  } catch (e) {
    console.error("Email failed:", e);
    // Don't throw — email failure shouldn't block the main action
  }
}

// Send "Package Shipped" notification
export async function sendPackageShippedEmail({ customerEmail, customerName, packageId, description, trackingNumber }) {
  try {
    const ejs = await getEmailJS();
    await ejs.send(SERVICE_ID, TEMPLATE_SHIPPED, {
      email:           customerEmail,
      customer_name:   customerName,
      package_id:      packageId,
      description:     description || "Package",
      tracking_number: trackingNumber || "—",
    });
    console.log("Email sent: package shipped");
  } catch (e) {
    console.error("Email failed:", e);
  }
}
